// extracted by mini-css-extract-plugin
export var container = "ParallaxTitle-module--container--znvt9";
export var overlay = "ParallaxTitle-module--overlay--KzEWb";
export var parallaxImageContainer = "ParallaxTitle-module--parallax-image-container--TJk6+";
export var title = "ParallaxTitle-module--title--9xB5y";